import { Fragment } from "react";
import { createPortal } from "react-dom";
import { Dialog, DialogPanel, Transition, TransitionChild } from "@headlessui/react";

export default function Modal({ children, isOpen, setIsOpen, size = "max-w-lg", closeOnOutsideClick = true }) {
  const handleClose = closeOnOutsideClick ? setIsOpen : () => {};

  return createPortal(
    <Transition show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-500" onClose={handleClose}>
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-900/50" />
        </TransitionChild>

        <div className="fixed inset-0 z-50 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <DialogPanel
                className={`relative transform rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 w-full ${size}`}
              >
                {children}
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>,
    document.body
  );
}
